export const sumImpressions = (popup: { popupClicked?; popupShown? }): number =>
  popup ? [popup.popupClicked, popup.popupShown].reduce((sum, n) => sum + (n || 0), 0) : 0;
